if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

const prevArrowHTML =
    `<button class="slick-arrow slick-prev">
        <svg width="15" height="12" viewBox="0 0 15 12" fill="none" stroke="currentColor" stroke-width="1"><path d="M 6 0 L 0 6 L 6 12 M 0 6 H 15" /></svg>
        <span>Prev</span>
    </button>`;
const nextArrowtHTML =
    `<button class="slick-arrow slick-next">
        <span>Next</span>
        <svg width="15" height="12" viewBox="0 0 15 12" fill="none" stroke="currentColor" stroke-width="1"><path d="M 9 0 L 15 6 L 9 12 M 15 6 H 0" /></svg>
    </button>`;

const slickOptions = {
    accessibility: false,
    prevArrow: prevArrowHTML,
    nextArrow: nextArrowtHTML
};

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    // Slick Slider with current slide number
    $('.js-slick_showIndex').each((i, el) => {
        let currentIndex = '01';
        let totalSlides =  '01';

        $(el).on('init', (e, s) => {
            currentIndex = (`0${(s.currentSlide+1)}`).slice(-2);
            totalSlides = (`0${s.slideCount}`).slice(-2);

            $(el).append(`
                <div class="slick-current_index">
                    <span class="d1">${currentIndex}</span>
                    <span class="d2">${totalSlides}</span>
                </div>
            `);
        });

        $(el).on('beforeChange', (e, s, c, n)=> {
            currentIndex = (`0${(n+1)}`).slice(-2);
            totalSlides = (`0${s.slideCount}`).slice(-2);

            $('.slick-current_index', el).html(`
                <span class="d1">${currentIndex}</span>
                <span class="d2">${totalSlides}</span>
            `);
        });
    });

    $('.sym-slides').slick( slickOptions );

    $('.js-slick-prev').click(function () {
        $(this).closest('.sym-slides').slick('slickPrev');
    });
    $('.js-slick-next').click(function () {
        $(this).closest('.sym-slides').slick('slickNext');
    });

})();